import BaseIntegration from '@/common/mixins/integrations/baseIntegration';

const VivaKuwaitIntegrationMixin = {
  extends: BaseIntegration,
  methods: {
    getPreRegistrationRedirectionActionImpl() {
      return () => {
        this.setActiveIntegrationInfo([{ key: 'lang', value: this.getLocale }]);
        this.registrationRedirection();
      };
    },
    getIntegrationParametersCheckImpl() {
      return (to) => {
        const userMsisdn = to.query.CGMSISDN;
        const userStatus = to.query.CGStatus;
        if (userMsisdn && userStatus) {
          this.$axios.get(`api/getStatus?status=${userStatus}&token=${userMsisdn}`).then((res) => {
            const statusResult = res.data;
            if (statusResult === 'FAILURE' || statusResult === 'BLACKLISTED') {
              this.$router.push('/');
            } else if (statusResult === 'ALREADY_REGISTERED') {
              this.$router.push('login');
            } else if (statusResult === 'SUCCESS') {
              if (parseInt(userStatus, 10) === 0) {
                this.$gtm.trackEvent({
                  event: 'CompleteRegistration',
                  category: 'MSISDN Registration',
                  action: 'Register 2 registration',
                  label: 'Register 2',
                });
              }
            }
          });
        }
      };
    },
  },
};
export default VivaKuwaitIntegrationMixin;



// WEBPACK FOOTER //
// ./src/common/mixins/integrations/vivaKuwaitIntegration.js